import { render } from "./MergeGroupsForm.vue?vue&type=template&id=b2d7867a"
import script from "./MergeGroupsForm.vue?vue&type=script&lang=js"
export * from "./MergeGroupsForm.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__